module.exports = __webpack_public_path__ + "font-awesome.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/font-awesome/font-awesome.svg?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.svg?v=4.7.0
// module chunks = 5